import {Injectable} from '@angular/core';
import {SocialListAdapter} from './social-list-adapter.interface';
import {SocialListType} from './social-list-type.type';
import {UserReactionsSocialListAdapter} from './adapters/user-reactions-social-list.adapter';
import {ProjectReactionsSocialListAdapter} from './adapters/project-reactions-social-list.adapter';
import {LocalSubjectReactionsSocialListAdapter} from './adapters/local-subject-reactions-social-list.adapter';
import {UserFollowsSocialListAdapter} from './adapters/user-follows-social-list.adapter';
import {ProjectFollowsSocialListAdapter} from './adapters/project-follows-social-list.adapter';
import {EventFollowsSocialListAdapter} from './adapters/event-follows-social-list.adapter';
import {PlaceCheckInsSocialListAdapter} from './adapters/place-check-ins-social-list.adapter';

@Injectable({providedIn: 'root'})
export class SocialListAdapterRegistryService {
  constructor(
    private readonly userReactionsAdapter: UserReactionsSocialListAdapter,
    private readonly projectReactionsAdapter: ProjectReactionsSocialListAdapter,
    private readonly localSubjectReactionsAdapter: LocalSubjectReactionsSocialListAdapter,
    private readonly userFollowsAdapter: UserFollowsSocialListAdapter,
    private readonly projectFollowsAdapter: ProjectFollowsSocialListAdapter,
    private readonly eventFollowsAdapter: EventFollowsSocialListAdapter,
    private readonly placeCheckInsAdapter: PlaceCheckInsSocialListAdapter,
  ) {
  }

  public get(type: SocialListType): SocialListAdapter<any, any, any> {
    switch (type) {
      case 'user-reactions':
        return this.userReactionsAdapter;
      case 'project-reactions':
        return this.projectReactionsAdapter;
      case 'local-subject-reactions':
        return this.localSubjectReactionsAdapter;
      case 'user-follows':
        return this.userFollowsAdapter;
      case 'project-follows':
        return this.projectFollowsAdapter;
      case 'event-follows':
        return this.eventFollowsAdapter;
      case 'place-check-ins':
        return this.placeCheckInsAdapter;
      default:
        throw new Error(`Unsupported social list type: ${type}`);
    }
  }
}
